// extracted by mini-css-extract-plugin
module.exports = {"internalLink":"style_internalLink__pQnJZMObDd0eZW1toOZIO","listInternalLink":"style_listInternalLink__1fkh51zgOIt0Nd08_EqavI"};